import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'ham-accordion-item',
    templateUrl: './accordion-item.component.html',
    styleUrls: ['./accordion-item.component.scss'],
    animations: [
        trigger('expandCollapse', [
            state('expanded', style({ height: '*', padding: '1em' })),
            state('collapsed', style({ height: '0px', padding: '0em' })),
            transition('expanded <=> collapsed', animate('300ms ease-in-out')),
        ]),
    ],
})
export class HamAccordionItemComponent implements OnInit {
    @Input() disabled = false;
    @Input() isDragging = false;
    @Input() isOpened = false;
    @Input() backgroundColor: string = '#f9fafb';
    @Output() toggle = new EventEmitter<void>();
    @Output() opened = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();
    isHeld = false;

    constructor(private elRef: ElementRef) {}

    // Triggered when mouse button is pressed down
    onMouseDown() {
        this.isHeld = true;
    }

    // Triggered when mouse button is released
    onMouseUp() {
        this.isHeld = false;
    }

    private _filled = false;
    @Input()
    get filled(): any {
        return this._filled;
    }
    set filled(filled: any) {
        if (this._filled !== filled) {
            this._filled = filled;
        }
    }

    private _isCorrect: boolean | null | undefined;
    @Input()
    get isCorrect(): boolean | null | undefined {
        return this._isCorrect;
    }
    set isCorrect(isCorrect: boolean | null | undefined) {
        if (this._isCorrect !== isCorrect) {
            this._isCorrect = isCorrect;
        }
    }

    private _expanded = false;
    set expanded(value: boolean) {
        if (value && value != this._expanded) {
            this.opened.emit();
        } else if (value != this._expanded) {
            this.closed.emit();
        }

        this._expanded = value;
    }
    get expanded(): boolean {
        return this._expanded;
    }

    public onToggle() {
        if (!this.disabled) {
            this.toggle.emit();
        }
    }

    ngOnInit(): void {
        this.expanded = this.isOpened;
        this.updateClosedBodyBackgroundColor();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isOpened']) {
            this.expanded = this.isOpened;
        }
        this.updateClosedBodyBackgroundColor();
    }

    private updateClosedBodyBackgroundColor() {
        const accordionBodyClosed = this.elRef.nativeElement.querySelector('.accordion-body-closed');
        const accordionBody = this.elRef.nativeElement.querySelector('.accordion-body');
        const accordionHeader = this.elRef.nativeElement.querySelector('.accordion-header');

        if (accordionBodyClosed) {
            accordionBodyClosed.style.setProperty('--background-color', this.backgroundColor);
        }
        if (accordionBody) {
            accordionBody.style.setProperty('--background-color', this.backgroundColor);
        }

        if (accordionHeader) {
            accordionHeader.style.setProperty('--background-color', this.backgroundColor);
        }
    }
}
